export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actes"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier les informations sur le collecteur"])}
}